export const AdminProductsEndpoints = {
  root: '/products',
  types: '/products/types',
  attributes: '/products/attributes',
  attributes_values: '/products/attributes/values',
  variations: '/products/variations'
}
